import { render, staticRenderFns } from "./ColumnDate.vue?vue&type=template&id=2e0e2893&lang=pug&"
import script from "./ColumnDate.vue?vue&type=script&lang=js&"
export * from "./ColumnDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports